import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center"
    },
    text: {
        textAlign: "center"
    },
    image: {
        width: 144,
        height: 17
    }
});
export default stylesheet;
